import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button"; // Import Button component
import { useMediaQuery } from "@mui/material";

import logo from "../../assets/images/stoxboxlogo.png";
import bpWealthLogo from "../../assets/images/bpwealthLogoHighres.png";
import { useLocation } from "react-router-dom";

function NavBar(props) {
  const searchParams = new URLSearchParams(window.location.search);
  let plan_code = searchParams.get("plan_code");

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: "transparent" }}>
      <Container maxWidth="xl">
        <Toolbar>
          <Typography
            variant="h6"
            noWrap
            component="span"
            href=""
            sx={{
              mr: 2,
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            <img
              src={window.location.href.includes('/settlement') || plan_code === 'MENTORBOX_SETTLEMENT_PLAN' ? bpWealthLogo : logo}
              style={{ width: 145, textAlign: "center" }}
              alt="stox_box_logo"
            />
          </Typography>

          <Box sx={{ flexGrow: 1 }}>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            ></Menu>
          </Box>

          {/* Home Button */}
          {props.isLogo === "true" ? (
            <Button
              variant="outlined"
              color="primary"
              component="a"
              href="/"
              sx={{
                display: "flex",
                fontSize: "10px",
              }}
            >
              Go to home
            </Button>
          ) : null}
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default NavBar;
